"use client"

import { Suspense, useEffect } from "react"
import ForceLightTheme from "@/components/ForceLightTheme"
import { useAnalytics } from "@/hooks/use-analytics"

function AnalyticsWrapper() {
  useAnalytics()
  return null
}

export default function ClientRoot({ children }: { children: React.ReactNode }) {
  // Global error handler to suppress CSP violations
  useEffect(() => {
    const originalConsoleError = console.error
    console.error = (...args) => {
      const message = args[0]?.toString() || ''
      
      // Suppress RazorPay header errors (multiple variations)
      if (message.includes('Refused to get unsafe header') && message.includes('x-rtb-fingerprint-id')) {
        return
      }
      
      // Suppress Google Analytics CSP violations
      if (message.includes('Refused to connect') && message.includes('google-analytics.com')) {
        return
      }
      
      // Suppress RazorPay frame-src violations
      if (message.includes('Refused to frame') && message.includes('razorpay.com')) {
        return
      }
      
      // Suppress RazorPay lumberjack tracking errors
      if (message.includes('Refused to connect') && message.includes('lumberjack.razorpay.com')) {
        return
      }
      
      originalConsoleError.apply(console, args)
    }

    return () => {
      console.error = originalConsoleError
    }
  }, [])

  return (
    <>
      <Suspense fallback={null}>
        <AnalyticsWrapper />
      </Suspense>
      <ForceLightTheme />
      {children}
    </>
  )
} 